import { useState } from "react";
import {
  getBulkCampaigns,
  postBulkCampaigns,
  deleteBulkCampaign,
  downloadBulkCampaign,
  postCancelBulkCampaign,
  postPauseBulkCampaign,
  postResumeBulkCampaign
} from "V2.0/services/bulkCampaign";
import { createLinkAndDownloadAsCSV } from "V2.0/HomePages/Downloads/helpers/create_download_as_csv";

export function useBulkCampaigns(workspaceId) {
  const [bulkCampaigns, setBulkCampaigns] = useState({
    data: [],
    isLoading: true,
  });

  async function fetchBulkCampaigns() {
    try {
      const response = await getBulkCampaigns({ workspaceId });

      if (response.status === 200) {
        const reverseData = response.data.reverse();
        setBulkCampaigns({
          data: reverseData,
          isLoading: false,
        });
      }
    } catch (e) {
      setBulkCampaigns((prevState) => {
        return {
          ...prevState,
          isLoading: false,
        };
      });
    }
  }

  async function createBulkCampaign(payload, lifecycleCbs) {
    lifecycleCbs.init();
    console.log({ payload });

    try {
      const response = await postBulkCampaigns({ workspaceId, payload });

      if (response.status === 200) {
      lifecycleCbs.success();
      fetchBulkCampaigns();
      }
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function removeBulkCampaign(bulkCampaignId, lifecycleCbs) {
    lifecycleCbs.init();

    try {
      const response = await deleteBulkCampaign({workspaceId, bulkCampaignId});

      if (response.status === 200 ){
        lifecycleCbs.success();
        fetchBulkCampaigns();
      }
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function downloadBulkCampaignData(bulkCampaign, lifecycleCbs) {
    lifecycleCbs.init(bulkCampaign?.name);

    try {
      const response = await downloadBulkCampaign({
        workspaceId,
        bulkCampaignId: bulkCampaign._id,
      });

      if (response.status === 200) {
        const data = response.data;

        const fileName = `bulk_campaign-${bulkCampaign._id}`;

        createLinkAndDownloadAsCSV(data, fileName);
        lifecycleCbs.success(fileName, bulkCampaign?.name);
      }
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function resumeBulkCampaign(bulkCampaignId, lifecycleCbs) {
    lifecycleCbs.init();

    try {
      const response = await postResumeBulkCampaign({
        workspaceId,
        bulkCampaignId,
      });

      lifecycleCbs.success();
      fetchBulkCampaigns();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function pauseBulkCampaign(bulkCampaignId, lifecycleCbs) {
    lifecycleCbs.init();

    try {
      const response = await postPauseBulkCampaign({
        workspaceId,
        bulkCampaignId,
      });

      lifecycleCbs.success();
      fetchBulkCampaigns();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function cancelBulkCampaign(bulkCampaignId, lifecycleCbs) {
    lifecycleCbs.init();

    try {
      const response = await postCancelBulkCampaign({
        bulkCampaignId,
        workspaceId,
      });

      lifecycleCbs.success();
      fetchBulkCampaigns();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  return {
    bulkCampaignsData: bulkCampaigns.data,
    isBulkCampaignsLoading: bulkCampaigns.isLoading,
    setBulkCampaigns,
    fetchBulkCampaigns,
    createBulkCampaign,
    removeBulkCampaign,
    downloadBulkCampaignData,
    resumeBulkCampaign,
    pauseBulkCampaign,
    cancelBulkCampaign
  };
}
